<template>
    <div>
        <van-nav-bar class="header" :title="activityTheme" left-arrow @click-left="onClickLeft" fixed/>
        <van-list
                v-model="loading"
                class="list-box"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
            <div class="item-box" v-for="item in list" :key="item.uuid">
                <div class="item-content">
                    <p>姓名：{{item.name}}</p>
                    <span>联系方式：{{item.mobile}}</span>
                </div>
                <div class="item-content" style="text-align: right;">
                    <p class="createTime">{{item.createTime}}</p>
                    <van-icon name="edit" class="iconEdit" @click="toDetail(item.customerId)" />
                </div>

            </div>
        </van-list>



    </div>
</template>

<script>
    import {CellGroup,Button,Field,NavBar,Cell, List, Icon, } from 'vant';
    import moment from "moment";
    // import {getKey} from "../utils/url";
    import activityListService from "../../service/activityListService";
    export default {
        data: function () {
            return {
                activityTheme:'我的客户',
                uuid:'',
                list: [],
                loading: false,
                finished: false,
                pageIndex:0,
                pageSize:20,
                expressions:'[{"field":"数量","expression":"count(1)"}]',
                dictionaryNames:''

            }
        },
        components: {
            [Icon.name]: Icon,
            [Cell.name]: Cell,
            [List.name]: List,
            [Field.name]: Field,
            [Button.name]: Button,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup
        },
        computed: {
        },
        mounted: function() {
            this.uuid = this.$route.query.id;
        },
        methods:{
            async onLoad() {
                this.pageIndex++;
                let resp = await activityListService.getActivityCustomerList(this.dictionaryNames,this.expressions,this.pageSize,this.pageIndex,this.uuid);
                if (resp.data.Status === "1") {
                    resp.data.Data.data.forEach(item => {
                        item.createTime = moment(item.createTime).format('YYYY-MM-DD');
                    });
                    this.list = [...this.list, ...resp.data.Data.data];
                    // 加载状态结束
                    this.loading = false;

                    // 数据全部加载完成
                    this.finished = resp.data.Data.total <= this.list.length;
                }

            },
            onClickLeft() {
                this.$router.go(-1);
            },
            toDetail(id) {
                this.$router.push({path:"CustomerDetail",query:{id:id,activityId:this.uuid}})
            }
        }
    };

</script>
<style scoped>
    .header {
        height:120px;
    }
    .van-nav-bar__left {
        height:100%;
    }
    .van-nav-bar__left i {
        font-size:1.5rem;
    }
    .list-box {
        margin-top: 120px;
    }
    .item-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:30px 15px;
        border-bottom:1px solid #cccccc;
    }
    .item-box img {
        width:3rem;
        height:3rem;
    }
    .item-content {
        margin:0 30px;
    }
    .item-content p {
        margin:0;
        margin-bottom:10px;
        font-size:1rem;
        color:#333;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .item-content span {
        font-size:0.8rem;
        color:#333;
    }
    .createTime {
        font-size:0.8rem;
        margin:0;
        color: #999999;
    }
    .iconEdit {
        color:#1890ff;
        margin-top:10px;
        font-size: 1.2rem;
    }
</style>
